<div class="flex flex-row h-screen w-screen">
  <app-admin-sidebar></app-admin-sidebar>
  <main class="flex flex-col min-h-screen ml-[280px] w-full py-8 px-16">
    <router-outlet> </router-outlet>
  </main>
</div>
